import React from 'react';
import Layout from '../layout';
import AboutUsSectionOne from '../components/Esper/AboutUs/AboutUsSectionOne';

import AboutUsSectionTwo from '../components/Esper/AboutUs/AboutUsSectionTwo';
import EsperMission from '../components/Esper/AboutUs/EsperMission';
import AboutUsInvestors from '../components/Esper/AboutUs/AboutUsInvestors';
import AboutUsSectionThree from '../components/Esper/AboutUs/AboutUsSectionThree';
import messages from '../i18n/en';
import AboutUsSectionCareer from '../components/Esper/AboutUs/AboutUsSectionCareer';
export default (props: any) => (
  <Layout
    messages={messages}
    title={`About Us | Esper`}
    description={`Learn more about Esper, the first complete enterprise mobility management and Android DevOps platform for single-purpose enterprise devices. `}
    keywords={`About Esper, Android Devops`}
    className="first-page"
    location={props.location}
  >
    <AboutUsSectionOne messages={messages} />
    <AboutUsSectionTwo messages={messages} />
    <EsperMission messages={messages} />
    <AboutUsSectionThree messages={messages} />
    <AboutUsSectionCareer messages={messages} />
    <AboutUsInvestors messages={messages} />
  </Layout>
);
